import { EnvironmentProperty } from './environment.model';

export const environment: Partial<EnvironmentProperty> = {
  apiDomain: 'https://data-dev3.hdw.hrsa.gov/HDWLocatorApi',
  uxDomain: 'https://data-dev3.hdw.hrsa.gov/ux',
  home: 'https://data-dev3.hdw.hrsa.gov',
  isDevMode: true,
  production: false,
  baseHref: '/',
  analyticsId: 'GTM-MVDSQT',
  authToken: null
};
